import { Dialog, Text, COLORS } from "@asayinc/component-library";
import { Stack } from "@mui/material";
import { toast } from "react-toastify";

import { useDeleteAdditionalMailingRequestMutation } from "src/store/additionalMailingRequest/api";
import { getErrorMessage } from "src/utils/isErrorWithMessage";

interface DeleteAdditionalMailingRequestDialogProps {
  open: boolean;
  onClose: () => void;
  proxyEventId: string;
  requestId: string | null;
}

export function DeleteAdditionalMailingRequestDialog({
  open,
  onClose,
  proxyEventId,
  requestId,
}: DeleteAdditionalMailingRequestDialogProps) {
  const [deleteRequest, { isLoading }] =
    useDeleteAdditionalMailingRequestMutation();

  const onConfirm = () => {
    if (!requestId) return;

    deleteRequest({ proxyEventId, id: requestId })
      .unwrap()
      .then(() => {
        toast.success("Request deleted successfully");
        onClose();
      })
      .catch((e) => {
        toast.error(getErrorMessage(e));
      });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Delete Additional Mailing Request"
      content={
        <Stack gap={2}>
          <Text variant="body2">
            Are you sure you want to delete this additional mailing request?
          </Text>
          <Text variant="body3" sx={{ color: COLORS.P_MED_LOW_EMPHASIS }}>
            This action cannot be undone.
          </Text>
        </Stack>
      }
      buttonActions={[
        {
          label: "Cancel",
          onClick: onClose,
          variant: "secondary",
          size: "small",
          disabled: isLoading,
        },
        {
          label: isLoading ? "Deleting..." : "Delete",
          onClick: onConfirm,
          loading: isLoading,
          size: "small",
          variant: "primary",
        },
      ]}
      ctaOrientation="horizontal"
    />
  );
}
